import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";

export default class UpdateAccountGeneralProductSettings extends BaseUpdateAccountSettings {
    productId: string;
    productIssueId: string;

    public constructor(productId?: string, productIssueId?: string, updatedAt?: Date) {
        super(updatedAt);
        if (productId) {
            this.productId = productId;
        }
        if (productIssueId) {
            this.productIssueId = productIssueId;
        }
    }
}